module.exports = __webpack_public_path__ + "img/pic03_index.41e4ef96.png";